'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _cookieApi = require('./cookieApi.js');

var _cookieApi2 = _interopRequireDefault(_cookieApi);

var _utils = require('./utils.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CookieDataEnricher = function () {
    function CookieDataEnricher(cookies, env) {
        _classCallCheck(this, CookieDataEnricher);

        this._cookieApi = new _cookieApi2.default(cookies, env);
    }

    _createClass(CookieDataEnricher, [{
        key: 'enrich',
        value: function enrich(eventData) {
            this.setLoggedOutGuid(eventData);
            (0, _utils.setValueOrEmptyString)("logged_in_guid", this._cookieApi.getAnalyticsCookie().logged_in_guid, eventData);
            (0, _utils.setValueOrEmptyString)("ab_logged_in_guid", this._cookieApi.getAbCookie(), eventData);
            this.setUserIdentity(eventData);
            eventData = this._setKissmetricsCookieProperties(eventData);
            return eventData;
        }
    }, {
        key: 'setLoggedOutGuid',
        value: function setLoggedOutGuid(eventData, setAnalyticsCookie) {
            var logged_out_guid = this._cookieApi.getAnalyticsCookie().logged_out_guid;
            if (!logged_out_guid) {
                logged_out_guid = (0, _utils.generateGUID)();
                typeof setAnalyticsCookie === 'function' ? setAnalyticsCookie(logged_out_guid, '') : this._cookieApi.setAnalyticsCookie(logged_out_guid, '');
            }
            (0, _utils.setValueOrEmptyString)("logged_out_guid", logged_out_guid, eventData);
        }
    }, {
        key: 'setUserIdentity',
        value: function setUserIdentity(eventData, setUserIdentityCookie) {
            var authEmail = this._cookieApi.getAuthUserEmail();
            var loggedIn = 0;
            if (authEmail) {
                loggedIn = 1;
            } else {
                authEmail = this._cookieApi.getKOALAEmailIdentity() || this._cookieApi.getKissmetricsCookie();
                if (authEmail && authEmail.indexOf('@') === -1) {
                    authEmail = null;
                }
            }

            if (authEmail) {
                typeof setUserIdentityCookie === 'function' ? setUserIdentityCookie(authEmail) : this._cookieApi.setKOALAEmailIdentity(authEmail);
            }

            (0, _utils.setValueOrEmptyString)("is_logged_in", loggedIn, eventData);
            (0, _utils.setValueOrEmptyString)("email", authEmail, eventData);
        }
    }, {
        key: '_setKissmetricsCookieProperties',
        value: function _setKissmetricsCookieProperties(eventData) {
            var cookieValue = this._cookieApi.getKissmetricsCookie();
            if (typeof cookieValue !== 'string') {
                return eventData;
            }

            if (cookieValue.indexOf('@') === -1) {
                (0, _utils.setValueOrEmptyString)("km_id", cookieValue, eventData);
            } else {
                (0, _utils.setValueOrEmptyString)("km_email", cookieValue, eventData);
            }

            return eventData;
        }
    }]);

    return CookieDataEnricher;
}();

exports.default = CookieDataEnricher;


// WEBPACK FOOTER //
// ../~/@jg/koala-front-end-analytics/lib/lib/cookieDataEnricher.js